module.exports = __webpack_public_path__ + "img/wavy_loader.2ac06c54.png";